import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      height: "100%",
      textAlign: "center",
      background: theme.palette.secondary.main,
    },
    content: {
      paddingTop: 8,
      paddingBottom: 46,
      [theme.breakpoints.up("mobile")]: {
        width: 688,
        margin: [0, "auto"],
      },
      [theme.breakpoints.up("tablet")]: {
        width: "auto",
        paddingTop: 15,
        paddingLeft: 0,
        paddingRight: 0,
        maxWidth: "663px",
      },
    },
    title: {
      textAlign: "left",
      marginBottom: 8,
      fontSize: theme.typography.pxToRem(26),
      lineHeight: theme.typography.pxToRem(26),
      color: theme.palette.common.white,
      letterSpacing: ".5px",
      fontWeight: 500,
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 15,
        fontSize: theme.typography.pxToRem(36),
        lineHeight: theme.typography.pxToRem(36),
      },
    },
    paper: {
      padding: [16, 8],
      [theme.breakpoints.up("mobile")]: {
        padding: [25, 18],
      },
      [theme.breakpoints.up("tablet")]: {
        padding: [28, 22],
      },
    },
    backBtn: {
      display: "inline-block",
      marginTop: "30px",
      fontWeight: "bold",
      textDecoration: "underline",
    },
  }),
  { name: "Overview" },
);
